module.exports = __webpack_public_path__ + "img/logo-sa-clearinghouse-white.9f70762a.png";